import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import Pagination from '@mui/material/Pagination';
import CreateEditUser from '../../components/CreateEditUser';
import Notification from '../../components/Notification';
import Inventory from '../../components/Inventory';
import useApi from '../../api/useApi';
import { roles } from '../../Constants';

function Table() {
  const user = sessionStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const location = useLocation();
  const [openCreate, setOpenCreate] = useState(false);
  const [{ isLoading, isError, data }, getData] = useApi();
  const [organizationData, getOrganizationData] = useApi();
  const [state2, postData] = useApi();
  const [users, setUsers] = useState([]);
  const [selectedUser, selectUser] = useState({ id: '', name: '', password: '', cpassword: '', email: '' });
  const [state, deleteUser] = useApi();
  const [action, setAction] = useState('');
  const [notification, setNotification] = useState(false);
  const [type, setType] = useState(null);
  const [message, setMessage] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [orgData, setOrgData] = useState([]);
  const [formData, setFormData] = useState({
    q: '',
    role: '',
    isActive: '',
    orgId: '',
    email: '',
    password: '',
    cpassword: '',
  });
  const [onClose, setOnClose] = useState(false);
  const [onPassword, setOnPasswordChange] = useState(false);
  const day = 1000 * 60 * 60 * 24;
  // let org = [];
  let itemsPerPage;
  if (window.screen.height <= 768) itemsPerPage = 10;
  else if (window.screen.height > 768 && window.screen.height <= 980) itemsPerPage = 12;
  else if (window.screen.height > 980 && window.screen.height <= 1080) itemsPerPage = 15;
  else if (window.screen.height > 1080 && window.screen.height <= 1440) itemsPerPage = 18;
  else if (window.screen.height > 1440 && window.screen.height <= 1800) itemsPerPage = 21;
  else if (window.screen.height > 1800 && window.screen.height <= 2160) itemsPerPage = 24;
  else if (window.screen.height > 2160) itemsPerPage = 27;
  const [pageCount, setpageCount] = useState(0);
  const [page, setPage] = useState(1);
  const [searchFlag, setSearchFlag] = useState(false);
  const handleChange = (event, value) => {
    setPage(value);
  };

  const getTimeoffset = (ts) => {
    const _date = new Date(ts);
    return moment(_date).fromNow();
  };

  const orgId = JSON.parse(sessionStorage.user).organization.id;

  useEffect(() => {
    getData(`/users?limit=${itemsPerPage}&page=${page}`, 'GET');
    getOrganizationData(`/organizations`, 'GET');
  }, []);

  useEffect(() => {
    if (!organizationData.isLoading && !organizationData.isError && organizationData.data) {
      setOrgData(organizationData.data.organization);
    }
  }, [organizationData.isLoading, organizationData.isError, organizationData.data]);

  useEffect(() => {
    if (!formData.role && formData.orgId) {
      getData(`/users?limit=${itemsPerPage}&page=${page}&org=${formData.orgId}`, 'GET');
    } else if (!formData.role && !formData.orgId) {
      getData(`/users?limit=${itemsPerPage}&page=${page}`, 'GET');
    } else {
      getData(`/users?limit=${itemsPerPage}&page=${page}&role=${formData.role}&org=${formData.orgId}`, 'GET');
    }
  }, [page]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.password === formData.cpassword) {
      const body = {
        emailId: selectedUser.email,
        userSecret: formData.password,
      };
      // console.log("bod", body);
      postData('/setPassword', 'POST', body);
    } else {
      setType('error');
      setMessage('Password and Confirm Password should match.');
      setNotification(true);
    }
  };

  useEffect(() => {
    if (!isLoading && !isError && data) {
      const _users = data.users.sort((a, b) => (a.userName.toLowerCase() > b.userName.toLowerCase() ? 1 : -1));
      // const org = [
      //   ...new Map(
      //     _users.map((item) => [
      //       item?.Organization?.organizationName,
      //       { id: item?.Organization?.id, name: item?.Organization?.organizationName },
      //     ])
      //   ).values(),
      // ];

      // setOrgData(org);
      setFilteredData(_users);
      let z = _users;
      if (formData.status) {
        z = z.filter((x) => x?.isActive.toString() === formData.status);
      }
      if (z.length > 0) setUsers(z);
      else setUsers([]);
      if (page === 1) {
        let total = Math.ceil((data.count || data.users.length) / itemsPerPage);
        if (isNaN(total)) total = 1;
        setpageCount(total);
      }
    }
    if (isError) {
      setType('error');
      setMessage('Unable to fetch user');
      setNotification(!notification);
    }
  }, [isLoading, isError, data]);

  const handleInputBoolean = useCallback((e) =>
    setFormData({
      ...formData,
      [e.target.name]: e.target.value === 'true' ? true : e.target.value === 'false' ? false : '',
    })
  );
  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));

  const toggleOpenCreate = () => {
    setOpenCreate((prev) => !prev);
  };

  const getRole = (roleCode) => {
    const x = roles.filter((role) => role.id.toString() === roleCode);
    return x[0].value;
  };

  const handleDelete = () => {
    deleteUser(`/user/${selectedUser.id}`, 'DELETE');
  };

  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      setType('success');
      setMessage('User Record deleted successfully');
      setNotification(!notification);
      getData(`/users?limit=${itemsPerPage}&page=${page}`, 'GET');
    }
    if (state.isError) {
      setType('error');
      setMessage('Unable to delete User Record');
      setNotification(!notification);
    }
  }, [state]);

  const createNotification = (types, messages) => {
    setType(types);
    setMessage(messages);
    setNotification(!notification);
  };

  const refreshList = () => {
    getData(`/users?limit=${itemsPerPage}&page=${page}`, 'GET');
    // toggleOpenCreate();
  };

  const hideNotification = (msg) => {
    setNotification(false);
  };

  const searchData = () => {
    setSearchFlag(true);
    // getData(`/search?type=project&searchItem=${formData.q}`, 'GET');
    getData(`/search?type=user&searchItem=${formData.q}`, 'GET');
  };

  useEffect(() => {
    if (formData.q === '') {
      setSearchFlag(false);
      setPage(1);
      getData(`/users?limit=${itemsPerPage}&page=1&role=${formData.role}&org=${formData.orgId}`, 'GET');
    }
  }, [formData.q]);

  useEffect(() => {
    if (state2.data !== null) {
      // refreshList();
      setType('success');
      setMessage('Password Changed Successfully');
      setNotification(!notification);
      setFormData({ q: '', role: '', isActive: '', orgId: '', email: '', password: '', cpassword: '' });
      // notification('success', 'Password Changed Successfully');
      setOnPasswordChange(false);
    }

    if (state2.isError) {
      notification('error', 'Unable to change password');
    }
    // console.log("!state.isError",state2.isError)
  }, [state2]);

  useEffect(() => {
    setSearchFlag(false)
    if (formData.orgId === '') {
      getData(`/users?limit=${itemsPerPage}&page=${page}&role=${formData.role}`, 'GET');
    }
    if (page === 1 && (formData.role || formData.orgId)) {
      getData(`/users?limit=${itemsPerPage}&page=${page}&role=${formData.role}&org=${formData.orgId}`, 'GET');
    } else setPage(1);
  }, [formData.role, formData.orgId]);

  return (
    <>
      {notification && <Notification type={type} message={message} hideNotification={hideNotification} />}
      {onClose && (
        <div
          className="flex justify-center items-center h-full w-full fixed z-20"
          style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
        >
          <div className="bg-white w-full md:w-3/12 px-2 text-sm block m-auto rounded-2xl relative">
            <span className="block p-4 font-bold border-b text-textBlue1">Delete User</span>
            <img
              src="assets/img/Close.svg"
              className="absolute top-3 right-3 h-3 cursor-pointer"
              alt=""
              onClick={() => setOnClose(false)}
            />
            <span className="block text-center text-sm my-8 user_colour">
              Do you want to delete User {selectedUser.name}?
            </span>
            <div className="mb-6 font-bold float-right mr-8 w-2/3">
              <div className="w-1/3" />
              <div className="w-full sm:w-2/3 flex">
                <button
                  type="submit"
                  className="mt-1 lg:mt-0 lg:w-max w-auto border px-8 py-4 rounded-3xl text-xs mr-2 focus:outline-none flex justify-center items-center h-7"
                  onClick={() => {
                    setOnClose(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="mt-1 lg:mt-0 w-auto lg:w-max border px-8 py-4 rounded-3xl text-xs font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                  onClick={handleDelete}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {onPassword && (
        <div
          className="flex justify-center items-center h-full w-full fixed z-20"
          style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
        >
          <div className="bg-white w-full md:w-4/12 px-2 text-sm block m-auto rounded-2xl relative">
            <span className="block p-4 font-bold border-b text-textBlue1">
              Change Password for {selectedUser.email}
            </span>
            <img
              src="assets/img/Close.svg"
              className="absolute top-3 right-3 h-3 cursor-pointer"
              alt=""
              onClick={() => setOnPasswordChange(false)}
            />
            <form className="mt-6 mb-6 mx-2 md:mx-10 flex flex-wrap" onSubmit={handleSubmit}>
              <div className="mt-4 w-full relative">
                <input
                  type="text"
                  placeholder="Password"
                  value={formData.password}
                  name="password"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange}
                  pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#\$%\^&\*]).{8,}"
                    title="Must contain at least one number and one uppercase and lowercase letter and one special character(!@#), and at least 8 or more characters"
                />
              </div>
              <div className="mt-4 w-full relative">
                <input
                  type="text"
                  placeholder="Confirm Password"
                  value={formData.cpassword}
                  name="cpassword"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange}
                  
                />
              </div>
              <div className="w-full relative mb-2 mt-4">
                {state2.isLoading || isLoading ? (
                  <div className="flex text-xs">
                    <img src="assets/img/loader.svg" className="w-16 right-28 mx-auto" alt="" />
                  </div>
                ) : (
                  <div className="flex text-xs w-full justify-center">
                    <button
                      type="submit"
                      onClick={() => setOnPasswordChange(false)}
                      className="rounded-3xl border focus:outline-none w-2/4 h-10 mr-3 cursor-pointer  "
                      // style={{ border: '1px solid #16406D' }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="rounded-3xl focus:outline-none w-2/4 h-10 text-white bg-btnBg cursor-pointer "
                      style={{ border: '1px solid #16406D' }}
                    >
                      Save
                    </button>
                  </div>
                )}
              </div>

              {/* <div className="flex w-full items-center justify-center  mt-6 relative">
            {state2.isLoading || isLoading ? (
              <img src="assets/img/loader.svg" className="w-16 right-36 mx-auto" alt="" />
            ) : (
              <input
                type="submit"
                className="rounded-lg focus:outline-none w-1/4 h-10 text-textBlue1 cursor-pointer "
                style={{ background: '#16406D33', border: '1px solid #16406D' }}
              />
            )}
          </div> */}
            </form>
          </div>
        </div>
      )}
      {openCreate && (
        <CreateEditUser
          handleClose={toggleOpenCreate}
          action={action}
          notification={createNotification}
          selectedUser={selectedUser.id}
          refreshList={() => refreshList()}
        />
      )}

      {location.pathname === '/inventory' && <Inventory />}
      <div
        className="mt-10 md:mt-0 lg:m-8 static md:fixed bg-white w-full md:w-10/12 overflow-auto md:overflow-hidden nav_user"
        style={{
          filter: (openCreate || location.pathname === '/inventory') && 'blur(2px)',
        }}
      >
        <div className="h-16 sm:h-40">
          <div className=" pt-4 md:pt-8 lg:flex block sm:block sm:justify-between text-left sm:text-center lg:text-left w-tableWidth m-auto ">
            <span className="text-textBlue1 font-bold text-lg">Users</span>

            <div className="flex float-right mt-1 lg:mt-0">
              <button
                className="mt-1 lg:mt-0 w-max border px-3 py-1 rounded-md text-xs mx-0 sm:mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  setAction('create');
                  toggleOpenCreate();
                }}
              >
                <img src="assets/img/Create.svg" className="h-3 mr-2 " alt="" />
                CREATE
              </button>

              <div className="mt-1 lg:mt-0 w-full text-xs lg:w-max border bg-transparent px-3 py-1.5 ml-3 flex justify-between items-center rounded-3xl button_search2 ">
                <input
                  type="text"
                  placeholder="Search"
                  autoComplete="off"
                  className="text-textBox bg-transparent focus:outline-none button_search2"
                  value={formData.q}
                  name="q"
                  onChange={handleInputChange}
                  style={{ borderColor: '#e6e6e6' }}
                  onKeyDown={(e) => {
                    if (e.which === 13) searchData();
                  }}
                />
                <img src="assets/img/Search.png" onClick={searchData} className="h-4 ml-2 button_search3 " alt="" />
              </div>
            </div>
          </div>
        </div>

        <div className="tbl">
          <div className="bg-white w-tableWidth m-auto mb-3" style={{ minWidth: '900px' }}>
            <div className="bg-white w-full flex border" style={{ borderColor: '#e6e6e6' }}>
              <div className="px-8 py-2 items-center flex w-full relative bg-primary text-white text-left text-xs font-bold">
                <div style={{ width: `${100 / 8}%` }}>NAME</div>
                {/* <div style={{ width: `${100 / 7}%` }}>
                  SHORT NAME
                </div> */}
                <div style={{ width: `${100 / 8}%` }}>EMAIL</div>
                <div className="py-1" style={{ width: `${100 / 5}%` }}>
                  <div className="relative inline-flex">
                    <svg
                      className="w-3 h-2 absolute top-3 right-4 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 412 232"
                    >
                      <path
                        d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                        fill="#ffffff"
                        fillRule="nonzero"
                      />
                    </svg>
                    <select
                      value={formData.orgId}
                      name="orgId"
                      className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-8 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md"
                      onChange={handleInputChange}
                      style={{ borderColor: '#e6e6e6' }}
                    >
                      <option value="">ORGANIZATION</option>
                      {orgData &&
                        orgData.length > 0 &&
                        orgData.map((item) => <option value={item?.id}>{item?.organizationName}</option>)}
                    </select>
                  </div>
                </div>
                <div style={{ width: `${100 / 8}%` }}>CONTACT</div>
                <div className="py-1" style={{ width: `${100 / 7}%` }}>
                  <div className="relative inline-flex">
                    <svg
                      className="w-3 h-2 absolute top-3 right-4 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 412 232"
                    >
                      <path
                        d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                        fill="#ffffff"
                        fillRule="nonzero"
                      />
                    </svg>
                    <select
                      value={formData.role}
                      name="role"
                      className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-8 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md"
                      onChange={handleInputChange}
                      style={{ borderColor: '#e6e6e6' }}
                    >
                      <option value="">ROLE</option>
                      {roles.map((item) => (
                        <option value={item.id}>{item.value}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div style={{ width: `${100 / 7}%` }}>
                  {' '}
                  <div className="relative inline-flex">
                    <svg
                      className="w-3 h-2 absolute top-3 right-4 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 412 232"
                    >
                      <path
                        d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                        fill="#ffffff"
                        fillRule="nonzero"
                      />
                    </svg>
                    <select
                      value={formData.isActive}
                      name="isActive"
                      className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-8 pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md"
                      onChange={handleInputBoolean}
                      style={{ borderColor: '#e6e6e6' }}
                    >
                      <option value="">STATUS</option>
                      <option value="true">ACTIVE</option>
                      <option value="false">INACTIVE</option>
                    </select>
                  </div>
                </div>
                <div style={{ width: `${100 / 8}%` }}>LAST MODIFIED</div>
                <div style={{ width: `${100 / 8}%` }}>ACTION</div>
                {/* <div className=" py-5 text-sm font-black" style={{ width: `${100 / 7}%` }}>
         AVATAR
        </div> */}
                {/* <img src="assets/img/Filter.svg" className="w-5 absolute top-5 right-3" /> */}
              </div>
            </div>
            {!isLoading ? (
              <div className="hideScroll" style={{ overflowY: 'scroll', height: '68vh' }}>
                {filteredData.map((item) => (
                  <div
                    className="my-1 px-8 flex
                    relative hover:border-indigo-200 focus-within:border-indigo-200 text-role py-2 items-center text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs"
                    style={{ border: '0.5px solid #C0C0C0', boxSizing: 'border-box', borderRadius: '4px' }}
                  >
                    {/* <input
                      type="checkbox"
                      className="absolute left-3 top-5"
                      checked={selectedUser === item.id}
                      onChange={() => {
                        selectedUser == item.id ? selectUser('') : selectUser(item.id);
                      }}
                    /> */}

                    <div
                      className="text-role text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs"
                      style={{ width: `${100 / 8}%` }}
                    >
                      {item?.userName}
                    </div>
                    {/* <div
                      // className="text-role py-4 overflow-ellipsis overflow-hidden whitespace-nowrap text-sm uppercase"
                      style={{ width: `${100 / 7}%` }}
                    >
                      {item?.slug}
                    </div> */}
                    <div
                      className="text-role text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs"
                      style={{ width: `${100 / 8}%` }}
                    >
                      {item?.email}
                    </div>
                    <div
                      className="text-role text-center overflow-ellipsis overflow-hidden whitespace-nowrap text-xs"
                      style={{ width: `${100 / 5}%` }}
                    >
                      {item?.Organization?.organizationName}
                    </div>
                    <div
                      className="text-role text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs"
                      style={{ width: `${100 / 8}%` }}
                    >
                      {item?.contact}
                    </div>
                    <div
                      // className="ml-8"
                      // className="text-role py-4 overflow-ellipsis overflow-hidden whitespace-nowrap text-sm uppercase"
                      style={{ width: `${100 / 7}%` }}
                    >
                      {getRole(item?.role)}
                    </div>
                    <div
                      // className="text-role py-4 overflow-ellipsis overflow-hidden whitespace-nowrap text-sm uppercase"
                      style={{ width: `${100 / 7}%` }}
                    >
                      {item?.isActive ? (
                        <p className="text-green-700"> ACTIVE</p>
                      ) : (
                        <p className="text-red-700"> INACTIVE</p>
                      )}
                    </div>
                    <div
                      // className="text-role py-4 overflow-ellipsis overflow-hidden whitespace-nowrap text-sm uppercase"
                      style={{ width: `${100 / 8}%` }}
                    >
                      {getTimeoffset(item?.updatedAt)}
                      {/* {new Date(item?.updatedAt).getDay() === 0
                        ? `${new Date(item?.updatedAt).getHours()} Hours Ago`
                        : `${new Date(item?.updatedAt).getDay()} Days Ago`} */}
                    </div>
                    <div style={{ width: `${100 / 8}%` }} className="flex">
                      <img
                        src="assets/img/Edit2.svg"
                        className="h-3 mr-4 "
                        alt=""
                        onClick={() => {
                          selectUser({ id: item?.id });
                          setAction('update');
                          toggleOpenCreate();
                        }}
                      />
                      <img
                        src="assets/img/Delete2.svg"
                        className="h-3 mr-4"
                        alt=""
                        onClick={() => {
                          selectUser({ id: item?.id, name: item?.userName });
                          // selectOrg({ id: item?.id, name: item?.organizationName});
                          setOnClose(true);
                        }}
                      />
                      <img
                        src="assets/img/DevicesIcon.svg"
                        alt=""
                        className="h-3"
                        onClick={() => {
                          selectUser({ email: item?.email });
                          setOnPasswordChange(true);
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
            )}
            {!searchFlag && (
              <div className="block lg:flex mt-1 lg:mt-0 fixed bottom-4 right-14">
                <Pagination
                  className="mt-4 ml-auto shadow-2xl"
                  count={pageCount}
                  page={page}
                  onChange={handleChange}
                  variant="outlined"
                  shape="rounded"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Table;
